<template>
    <div v-if="bizAuth.viewHouse.hasRight" class="page-setting biz-house-management parent-frame" :class="{'fixed': listIsFixed}" v-bind:style="{'min-height': myHeight}">
        <share-social-media :cid="seletedHouseCid"></share-social-media>
        <transition name="fade">
            <alart-msg :display="alart" styleType="success" @alartStatus="closeAlart">
                <span class="title" slot="title">房源新增成功</span>
            </alart-msg>
        </transition>
        <div class="tool-bar-mask"></div>
        <house-filter :isOpen="houseFilter" @filterClose="closeFilterMenu" ></house-filter>
        <Breadcrumb />
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <house-mgt-mode-switch></house-mgt-mode-switch>
                <table-search @changeWord="setFilterWord" :setDefault="true" :setWord="searchWord"></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
                <dot-large-drop-menu bg="#ff9275" bgHover="#eb7859">
                    <ul >
                        <li v-if="bizAuth.createHouse.hasRight" @click="toPage('bizAddHouse')">
                            刊登廣告
                        </li>
                        <li v-if="bizAuth.createHouse.hasRight"  @click="toPage('bizBatchUpload')">
                            批量刊登廣告
                        </li>
                        <li v-if="bizAuth.editContractPolicy.hasRight" @click="toPage('bizEditPolicy')">
                            自訂合約條款
                        </li>
                        <li v-if="bizAuth.onOrOffShelf.hasRight" @click="toPage('bizBatchPublish')">
                            批量設定上架
                        </li>
                        <li v-if="bizAuth.editContractPolicy.hasRight" @click="toPage('bizBatchPolicy')">
                            批量套用條款
                        </li>
                        <li  v-if="bizAuth.assignLandlordAndAgent.hasRight" @click="toPage('bizBatchDispatch')">
                            批量分派房東與業務
                        </li>
                         <li @click="toPage('bizBatchContractVersion')">
                            批量套用合約版本
                        </li>
                        <!-- <li v-if="bizAuth.editContractPolicy.hasRight">合約政策版本(待確認)</li>
                        <li>費用版本(待確認)</li>
                        <li>更新所有房源(待確認)</li>  -->
                    </ul>
                </dot-large-drop-menu >
            </div>
        </div>
        <tabs v-if="$route.query.mode === 'graph'" :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <house-mgt-graph state="0"></house-mgt-graph>
            </tab>
            <tab name="已租" :selected="selected.rented" >
                <house-mgt-graph state="1"></house-mgt-graph>
            </tab>
            <tab name="未租" :selected="selected.empty" >
                <house-mgt-graph state="2"></house-mgt-graph>
            </tab>
        </tabs>
        <tabs v-else :key="componentKey">
            <tab name="全部" :selected="selected.all" >
                <house-mgt-list state="0"></house-mgt-list>
            </tab>
            <tab name="已租" :selected="selected.rented" >
                <house-mgt-list state="1"></house-mgt-list>
            </tab>
            <tab name="未租" :selected="selected.empty" >
                <house-mgt-list state="2"></house-mgt-list>
            </tab>
        </tabs>
        <paginate
          v-model="pageNum"
          v-show="totalPage>1 && !HmgtIsLoading"
          :page-count="totalPage"
          container-class="pagination"
          :prev-text="paginateParams.prevLabel"
          :next-text="paginateParams.nextLabel"
          :click-handler="setPage">
        </paginate>
    </div>
</template>
<script>
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import DropMenu from '@/components/widge/DropMenu.vue';
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import HouseFilter from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseFilter.vue';
import HouseMgtGraph from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/graphMode/HouseMgtGraph.vue';
import HouseMgtList from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/listMode/HouseMgtList.vue';
import houseMgtModeSwitch from '@/components/bussiness/mgtCategory/houseMgt/houseMgt/houseMgtModeSwitch.vue';
import AlartMsg from '@/components/widge/AlartMsg.vue';
import DotLargeDropMenu from '@/components/widge/DotLargeDropMenu.vue';
import shareSocialMedia from '@/components/bussiness/widges/modals/shareSocialMedia.vue';
import paginate from 'vuejs-paginate';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            houseFilter: false,
            listIsFixed: false,
            alart: false,
            myHeight: (window.innerHeight - 84) + 'px',
            searchWord: null,
            selected: {
                all: false,
                rented: false,
                empty: false,
            },
            selectTab: null,
            paginateParams:{
              prevLabel: "<img src='"+require('@/assets/img/icon/arror_left_orange.svg')+"' />",
              nextLabel: "<img src='"+require('@/assets/img/icon/arror_right_orange.svg')+"' />",
            },
            componentKey: 0,
            pageNum: 1
        }
    },
    created (){
        this.$store.dispatch('setBizHouseMgtFilterDefault');
        // this.selectTabByHash()
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        this.$store.dispatch('setBizHouseMgtMode', 'list')
        if( this.$route.query.success && this.$route.query.success == 1){
            this.alart = true
            this.$router.replace('/bussiness/mgtCategory/houseMgt/')
        }
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                console.log(val)
                if(val.query.filterWord){
                    this.searchWord = val.query.filterWord
                    this.$router.replace({name: 'bizHouseMgtDefault'})
                }
                this.forceUpdate()
            },
            immediate: true,
            deep: true
        },
        'bizAuth.viewHouse.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        },
        page: function (val) {
          this.pageNum = val;
        }
    },
    methods: {
        toPage: function (page) {
            if(this.verifiedStatus === 'NORMAL'){
                this.$router.push({name: page})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)
            let houseStatus = 'ALL';
            if( hashTag == '#全部' ){
                console.log('房源管理_全部')
                this.$analyticsBiz.logEvent('房源管理_全部', { screen_name: '房源管理_全部'})
                this.selected.all = true
            }else if( hashTag == '#已租' ){
                console.log('房源管理_已租')
                this.$analyticsBiz.logEvent('房源管理_已租', { screen_name: '房源管理_已租'})
                this.selected.rented = true
                houseStatus = 'RENTED';
            }else if( hashTag == '#未租' ){
                console.log('房源管理_未租')
                this.$analyticsBiz.logEvent('房源管理_未租', { screen_name: '房源管理_未租'})
                this.selected.empty = true
                houseStatus = 'FOR_RENT';
            }else{
                console.log('房源管理_全部')
                this.$analyticsBiz.logEvent('房源管理_全部', { screen_name: '房源管理_全部'})
                this.selected.all = true
            }
            if (this.selectTab != houseStatus) {
                this.selectTab = houseStatus
                let data = {searchHouseItemStatus: houseStatus, page: 1}
                this.getHouseList(data)
            }
        },
        closeFilterMenu: function (value) {
            this.houseFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        // setFilterQuery: function (value) {
        //     this.$store.dispatch('setBizHouseMgtFilterQuery', value)
        // },
        setFilterWord: function (value) {
            let data = {keyword: value, page: 1}
            this.getHouseList(data)
        },
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                // console.log(scrollTop)
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        openFilter: function () {
            this.houseFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('parent-frame')[0].style.zIndex = '8'
        },
        closeAlart: function () {
            this.alart = false
        },
        setSelectTabAllFalse: function () {
            this.selected.all = false
            this.selected.rented = false
            this.selected.empty = false

        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1;
        },
        setPage: function(page) {
            let data = {page: page};
            this.getHouseList(data).then(()=>{
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            })
        },
        getHouseList: function (data) {
            return new Promise((resolve, reject) => {
              this.$store.dispatch('setBizHouseMgtFilterQuery', data)
                .then(()=>{
                  this.$store.dispatch('getBizHouseMgtListV2')
                })
              resolve()
            })
        }
    },
    computed: {
        ...mapGetters({
            filterWordIsEmpty: 'GET_BIZ_HOUSE_MGT_FILTER_WORD_IS_EMPTY',
            isModalMode: 'GET_MODAL_MODE',
            bizAuth: 'GET_BIZ_AUTH',
            seletedHouseCid: 'GET_BIZ_HOUSE_SELECT_CID',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            page: 'GET_BIZ_HOUSE_MGT_LIST_PAGE',
            totalPage :'GET_BIZ_HOUSE_MGT_LIST_TOTAL_PAGE',
            HmgtIsLoading: 'GET_BIZ_HOUSE_MGT_LOADING'

        })
    },
    components: {
        Tabs,
        Tab,
        DropMenu,
        AlartMsg,
        Breadcrumb,
        TableSearch,
        HouseFilter,
        HouseMgtGraph,
        HouseMgtList,
        houseMgtModeSwitch,
        DotLargeDropMenu,
        shareSocialMedia,
        paginate
    }
}
</script>
<style lang="scss">
  .biz-house-management {
    .pagination{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      // margin-top: -230px;
      li{
        margin: 0 6px;
      }
      li.active{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        border-radius: 4px;
        background-color: #eb7859;
        a{
          color: #fff;
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/houseMgtDefault.vue